import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../common/spinner';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import CustomerViewBasicInfo from '../customer/customerviewbasicinfo';
import { getCustomerFull } from '../modules/customerdata';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export default function SearchResultsCustomerDetails(props) {
    const dispatch = useDispatch();
    const customers = useSelector((state) => state.customerdata.customersById);
    const customerFull = customers[props.customer.id];
    const [expanded, setExpanded] = useState(false);
    const customer = props.customer;

    const onExpand = () => {
        setExpanded(!expanded);
        if (!customerFull) dispatch(getCustomerFull(customer.id));
    };

    const openCustomer = (event) => {
        props.history.push('/customers/' + customer.id);
        event.stopPropagation();
    };

    return (
        <React.Fragment>
            <Accordion expanded={expanded} onChange={onExpand}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Grid container direction="row" alignItems="center">
                        <Grid item>
                            <OpenInNewIcon onClick={(event) => openCustomer(event)} />
                        </Grid>
                        <Grid item>{customer.name}</Grid>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid item>
                        {customerFull && <CustomerViewBasicInfo customer={customerFull} />}
                        {!customerFull && <Spinner />}
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </React.Fragment>
    );
}
